<template>
<div id="app">
    <!-- class="animate" -->
    <router-view />
    <aside>
        <cookie-modal v-on:consentAccepted="acceptConsent"></cookie-modal>
    </aside>
</div>
</template>

<script>
import {
    configureLocaleUrl
} from "@/plugins/i18n";
import utils, {setHtmlElementLangAttribute,addLocaleToHtmlElementClass } from "@/common/utils";
import consent from "@/common/consent";
import CookieModal from "@/components/CookieModal.vue";

export default {
    components: {
        "cookie-modal": CookieModal,
    },
    created(){
        utils.configureConsent(consent);
        configureLocaleUrl(this);
    },
    mounted() {
        utils.configurePageAnimation();
        setHtmlElementLangAttribute(this.$i18n.locale)
        addLocaleToHtmlElementClass("lang-"+ this.$i18n.locale)
    },
    unmounted() {
    },
    methods: {
        acceptConsent() {
            consent.setStatus(true);
          //  console.log("Login::consent status is: " + consent.status)
            utils.wistiaCookieTracking(true);
        },
    },
};
</script>

<style lang="scss">
@import "./assets/styles/app.scss";
</style>
